export const BASE_URL = process.env.REACT_APP_API_URL;

console.log(BASE_URL);

export const API_URL_AUTH = `${BASE_URL}/auth`;
export const API_URL_ROLES = `${BASE_URL}/roles`;
export const API_URL_USERS = `${BASE_URL}/auth/users/all`;
export const API_URL_EMPLOYEES = `${BASE_URL}/employees`;
export const API_URL_CONFIGURATIONS = `${BASE_URL}/configurations`;
export const API_URL_MOVEMENTS = `${BASE_URL}/movements`;
export const API_URL_PRODUCTS = `${BASE_URL}/products`;
export const API_URL_SHOPPING = `${BASE_URL}/shopping`;
export const API_URL_SHOPPING_PRODUCTS = `${BASE_URL}/shopping-products`;
export const API_URL_EMAIL = `${BASE_URL}/emails`;
export const API_URL_MENUS = `${BASE_URL}/menus`;
export const API_URL_CLIENTS = `${BASE_URL}/clients`;
export const API_URL_PAYMENTS = `${BASE_URL}/payments`;
export const API_URL_PLANS = `${BASE_URL}/plans`;
export const API_URL_STORES = `${BASE_URL}/stores`;
